var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"footer h5",class:{ "top-margin": _vm.$route.name === "Start" }},[_c('span',[_vm._v(_vm._s(_setup.footerText))]),_c('a',{attrs:{"href":`mailto:${_setup.footerEmailAddress}`}},[_vm._v(_vm._s(_setup.footerEmailAddress))])])
}
var staticRenderFns = []

export { render, staticRenderFns }